import { render, staticRenderFns } from "./BoxTitleText.vue?vue&type=template&id=bb241550&"
import script from "./BoxTitleText.vue?vue&type=script&lang=js&"
export * from "./BoxTitleText.vue?vue&type=script&lang=js&"
import style0 from "./BoxTitleText.vue?vue&type=style&index=0&id=bb241550&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports